import React from 'react'
import styles from './index.module.less'

interface IProps {
  flexible?: boolean
  width?: number
}

export default function Split(props: IProps) {
  const { flexible = true, width = 5 } = props
  if (flexible) {
    return <em className={styles.splitLine} style={{ width: `${width}px` }}></em>
  }
  return <em className={styles.splitLine} style={{ minWidth: `${width}px` }}></em>
}
